import AccordionItem from './AccordionItem'
import parse from 'html-react-parser'

const ClassesAccordion = ({ accordionData }) => {
    //

    const isInPerson = accordionData.inPerson
    const freeReg = accordionData.noReg === false
    const isSeries = accordionData.isSeries
    const meetingUrl = accordionData.meetingUrl

    //

    let location
    let reg

    if (isInPerson) {
        location = {
            inPersonVenue: accordionData.inPersonVenue,
            inPersonAddress: accordionData.inPersonAddress,
            inPersonAddress2: accordionData.inPersonAddress2,
            inPersonCity: accordionData.inPersonCity,
            inPersonState: accordionData.inPersonState,
            inPersonZip: accordionData.inPersonZip,
        }
    }

    if (freeReg) {
        reg = {
            regUrl: accordionData.meetingUrl,
        }
    }

    return (
        <div className="accordion-outer">
            <div className="accordion-inner">
                <ul className="accordion-list nostyle">
                    {isInPerson && location ? (
                        <AccordionItem
                            itemData={location}
                            key="location-item"
                            type="location"
                        />
                    ) : null}

                    {freeReg && isInPerson && !isSeries && meetingUrl !== '' ? (
                        <AccordionItem
                            itemData={reg}
                            key="reg-item"
                            type="reg"
                        />
                    ) : null}
                </ul>
            </div>
        </div>
    )
}

export default ClassesAccordion
